export type MonthlyRuleType = "calendar_day" | "day_of_week" | "last_day"
export type WeekdayOrdinal = "first" | "second" | "third" | "fourth" | "last"
export type Weekday = "sunday" | "monday" | "tuesday" | "wednesday" | "thursday" | "friday" | "saturday"

export const MONTHLY_RULE_TYPE_OPTIONS = [
  { value: "calendar_day" as const, label: "Calendar day" },
  { value: "day_of_week" as const, label: "Day of week" },
  { value: "last_day" as const, label: "Last day of the month" },
]

export const WEEKDAY_ORDINAL_OPTIONS = [
  { value: "first" as const, label: "First" },
  { value: "second" as const, label: "Second" },
  { value: "third" as const, label: "Third" },
  { value: "fourth" as const, label: "Fourth" },
  { value: "last" as const, label: "Last" },
]

export const WEEKDAY_OPTIONS = [
  { value: "monday" as const, label: "Monday" },
  { value: "tuesday" as const, label: "Tuesday" },
  { value: "wednesday" as const, label: "Wednesday" },
  { value: "thursday" as const, label: "Thursday" },
  { value: "friday" as const, label: "Friday" },
  { value: "saturday" as const, label: "Saturday" },
  { value: "sunday" as const, label: "Sunday" },
]

export function monthlyWeekdaySummary(
  monthlyRuleType: MonthlyRuleType | null | undefined,
  weekdayOrdinal: WeekdayOrdinal | null | undefined,
  weekday: Weekday | null | undefined
): string | null {
  if (monthlyRuleType === "last_day") return "on the last day of the month"
  if (monthlyRuleType !== "day_of_week" || !weekdayOrdinal || !weekday) return null

  const ordinal = WEEKDAY_ORDINAL_OPTIONS.find((option) => option.value === weekdayOrdinal)?.label.toLowerCase()
  const day = WEEKDAY_OPTIONS.find((option) => option.value === weekday)?.label
  if (!ordinal || !day) return null

  return `on the ${ordinal} ${day}`
}
